var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFwd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A1A1A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.1,105.3c3.3,0,6.6-1,9.5-2.9L87.4,86c4.8-3.2,7.7-8.6,7.7-14.4s-2.9-11.2-7.7-14.4L62.7,40.8 c-5.4-3.6-12-3.9-17.7-0.9s-9.1,8.7-9.1,15.2V88c0,6.5,3.4,12.2,9.1,15.2C47.6,104.7,50.4,105.3,53.1,105.3z M53.1,41.9 c2.5,0,5.1,0.8,7.3,2.3l24.7,16.4c3.8,2.5,5.9,6.5,5.9,11s-2.2,8.5-5.9,11L60.4,99c-4.1,2.8-9.2,3-13.6,0.7s-7-6.7-7-11.7V55.2 c0-5,2.6-9.3,7-11.7C48.9,42.4,51,41.9,53.1,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,106.8c1.1,0,2-0.9,2-2V38.2c0-1.1-0.9-2-2-2s-2,0.9-2,2v66.6C102.4,105.9,103.3,106.8,104.4,106.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwd);
export default __webpack_public_path__ + "static/media/fwd.08db75a403fa913a08d0b6638c8bca4f.svg";
export { ForwardRef as ReactComponent };